const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  textElipsiss: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  error: {
    color: theme.palette.error.main,
  },
})

export default styles
